<template>
    <b-card class="detail-card mb-0" header-class="rainValueGather10-card-bg" header-text-variant="white">
        <template #header>
            <h4 class="font-weight-bold">
                {{ `${point.name}` }}
            </h4>
            <div>
                {{ `(${point.lat}, ${point.long})` }}
            </div>
        </template>
        <div class="mb-2">
            Chọn điểm khác để so sánh:
            <v-select :options="listOtherPoint" :clearable="false" :multiple="true" :filterable="false"
                :searchable="false" label="name" v-model="selectedLayerPoint"></v-select>
        </div>
        <div style="display: flex; justify-content: space-between;">
            <DatePicker v-model="range" range lang="vi" format="DD/MM/YYYY" name="time" :shortcuts="shortcuts">
            </DatePicker>
            <v-select style="width: 240px;" v-model="type" class="ml-2" :options="typeOptions" :clearable="false"
                :filterable="false" :searchable="false"></v-select>
        </div>
        <b-overlay :show="isLoading" spinner-variant="primary" variant="light" opacity="0.5" blur="1px" rounded="sm">
            <b-row class="mt-2">
                <b-col cols="12" v-for="(item, index) in listMap" :key="item.name">
                    <LineChartStatistic v-if="point.chartType === 'line'" :series="listStatistic[index]"
                        :title="item.name" :unit="unit" :type="item.value" unit="m" :legend="point.legend" />
                    <BarChartStatistic v-if="point.chartType === 'bar'" :series="listStatistic[index]"
                        :title="item.name" :unit="unit" :type="item.value" />
                </b-col>
            </b-row>
        </b-overlay>
    </b-card>
</template>

<script>
import { mapActions } from 'vuex';
import DatePicker from 'vue2-datepicker';
import LineChartStatistic from '@/components/LineChartStatistic';
import BarChartStatistic from '@/components/BarChartStatistic';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/vi';
import { getRange, getHours, getYesterday } from '../utils/datetime';

export default {
    components: {
        DatePicker,
        LineChartStatistic,
        BarChartStatistic
    },
    async mounted() {
        await this.$nextTick();
        this.typeOptions = await this.getDataType();
        if (this.typeOptions.length === 0) return;
        this.type = this.mainData ?? this.typeOptions[0];
        this.range = getHours(24);
        this.getData();
    },
    props: {
        point: {
            type: Object,
            required: true
        },
        listLayerPoint: {
            type: Array,
            required: true
        },
        mainData: String
    },
    computed: {
        listOtherPoint() {
            return this.listLayerPoint.filter(item => item.id !== this.point.id);
        }
    },
    data: function () {
        return {
            shortcuts: [
                {
                    text: '24 giờ qua',
                    onClick() {
                        return getHours(24);
                    }
                },
                {
                    text: 'Hôm qua',
                    onClick() {
                        return getYesterday();
                    }
                },
                {
                    text: '1 tuần qua',
                    onClick() {
                        return getRange(7);
                    }
                },
                {
                    text: '2 tuần qua',
                    onClick() {
                        return getRange(14);
                    }
                },
                {
                    text: '1 tháng qua',
                    onClick() {
                        return getRange(31);
                    }
                },
                {
                    text: '2 tháng qua',
                    onClick() {
                        return getRange(61);
                    }
                },
                {
                    text: '3 tháng qua',
                    onClick() {
                        return getRange(92);
                    }
                },
                {
                    text: '6 tháng qua',
                    onClick() {
                        return getRange(183);
                    }
                },
                {
                    text: '1 năm qua',
                    onClick() {
                        return getRange(365);
                    }
                }
            ],
            range: [],
            unit: '',
            typeOptions: [],
            type: null,
            isLoading: false,
            listMap: [
                {
                    name: 'Theo thời gian',
                    value: 'flex'
                }
            ],
            listStatistic: [[]],
            selectedLayerPoint: []
        };
    },
    watch: {
        range() {
            this.getData();
        },
        type(value) {
            this.getData();
        },
        selectedLayerPoint() {
            this.getData();
        }
    },
    methods: {
        ...mapActions({
            getStatisticFlex: 'statistic/flex',
            getDataType: 'data/getDataType'
        }),
        async getData() {
            if (this.isLoading) return;
            this.isLoading = true;
            this.listStatistic = [[]];
            const listPoint = [this.point, ...this.selectedLayerPoint];
            for (const point of listPoint) {
                const listData = await this.getDataPoint(point.id);
                for (let i = 0; i < this.listMap.length; i++) {
                    this.listStatistic[i].push({
                        name: point.name,
                        data: listData[i]
                    });
                }
            }
            this.isLoading = false;
        },
        async getDataPoint(pointId) {
            try {
                const params = { pointId, type: this.type };
                if (this.range.length === 2) {
                    params.from = this.range[0];
                    const toDate = new Date(this.range[1]);
                    toDate.setHours(23, 59, 59, 999);
                    params.to = toDate.toISOString();
                }
                return await Promise.all([this.getStatisticFlex(params)]);
            } catch (error) { }
        }
    }
};
</script>
<style>
.mx-datepicker-sidebar {
    width: 120px;
}

.v-select .vs__selected-options {
    flex-wrap: nowrap;
    white-space: nowrap;
    overflow: hidden;
}
</style>
